import { render, staticRenderFns } from "./VueGal.vue?vue&type=template&id=5679df70&"
import script from "./VueGal.vue?vue&type=script&lang=js&"
export * from "./VueGal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports